import { cornType } from '@eigtech/shared-corn';
/** @deprecated */
export const claimResourceType = 'claim';
/** @deprecated */
export const claimsServiceCorn = (eventName) => cornType('claims', eventName);
/** @deprecated */
export const ClaimsServiceCornSchema = claimsServiceCorn();
